import { Component, OnInit, Input } from '@angular/core';
import { FormEditBaseComponent } from '@components/form-edit-base.component';
import { UntypedFormBuilder, Validators, FormGroup, ValidationErrors, FormControl, FormArray } from '@angular/forms';

import { UiService } from '@services/ui.service';
import { Site } from '@classes/site';
import { ActivatedRoute } from '@angular/router';
import { Client } from '@classes/client';


@Component({
  selector: 'app-form-contact',
  templateUrl: './form-contact.component.html',
  styleUrls: ['./form-contact.component.scss']
})
export class FormContactComponent extends FormEditBaseComponent implements OnInit {

  sites: Site[];
  clients: Client[];

  nameMaxLength = 50;
  commentMaxLength = 500;


  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private route: ActivatedRoute
  ) {
    super(uiSrv, fb);
  }

  ngOnInit() {
    super.ngOnInit();
    this.getRouteData();
  }

  private getRouteData(): void {
    this.route.data
      .subscribe((data: { clients: Client[] }) => {
        this.clients = data.clients;
      });
  }

}
